// import ttOne from "../../assets/images/al.jpeg"
// import ttTwo from "../../assets/images/tr.jpeg"
// import ttThree from "../../assets/images/mon.jpeg"

import { al, tr, mon } from "../../assets"

export const data = [
    {
        fade: "fade-up",
        img: al,
        four: "Alexis Kapriyano",
        para: "Founder @ myclouddoc",
        desc: "”We hired Zee and his team to develop for us our own software from concept to creation. Zee is very professional and always keeps everything documented very well. He went above and beyond for us and still is to this day. We managed to complete the project on time and has helped us map out the vision we had for it. Every client we show our software they've always had great things to say about it and that's all thanks to him & his team. If you're looking for a high-quality, professional & trustworthy software developer then look no further. Zee is my go-to guy for anything tech/software-related. Every single dollar was well spent. Looking forward to continuing this long-term partnership.”",
        link: "https://www.linkedin.com/in/alexiskyprianou/"
    },
    {
        fade: "fade-up",
        img: tr,
        four: "Tracye Lawyer",
        para: "Orthopedic Surgeon",
        desc: "”I hired Zeeshan for a very complex website development plan. My website involved quite a bit of encryption and HIPAA compliance for my clients. Everything that I asked for he was able to execute. He developed a plan before we began which included a timeline, pricing and specifics of what was going to be complete each month. He was always available anytime if I had any questions or concerns.I really don't know anything about website development and he explained everything clearly. He and his team were very thorough and professional during the developmental process. The pricing was realistic given the amount of work was done. I would highly recommend him for any website development. I will definitely use him again in the future.”",
        link: "https://www.linkedin.com/in/tracye-lawyer-b2406b1bb/"
    },
    {
        fade: "fade-up",
        img: mon,
        four: "Monifa Clarke",
        para: "Founder @ Plugsity",
        desc: "”Zeeshan's dedication and commitment to delivering quality work were evident from the moment he joined our team. He was very hands-on in his approach and worked tirelessly to ensure that every aspect of our web and mobile app was user-friendly and easy to navigate. We are grateful for all of his contributions”",
        link: "https://www.linkedin.com/in/monifa-clarke/"
    },
]